import { useEffect, useState } from "react";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import SystemModal from "../Common/SystemModal";
import numberToWords from "number-to-words";

const InventoryJournalPrintableWzStatement = (props) => {
  const Print = (e, controls) => {
    e.preventDefault();
    const printContents = document.getElementById("printablediv").innerHTML;
    const originalTitle = document.title;
    const newWindow = window.open("", "_blank");

    newWindow.document.open();
    newWindow.document.write(`
      <html>
        <head>
          <title>${originalTitle} - Print</title>
        </head>
        <body style="font-family: Arial, sans-serif; margin: 0; padding: .5cm; width: 21cm; height: 29.7cm;">
          ${printContents}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.onafterprint = () => {
      controls.close();
      newWindow.close();
    };
  };

  const [inv_info, setInvo_ifo] = useState("");
  const [clientinfo, setClientinfo] = useState("");
  const [invo_details, setInvo_details] = useState("");
  const [ledgerID_debited_name, setLedgerID_debited_name] = useState("");
  const [ledgerID_credited_name, setLedgerID_credited_name] = useState("");
  const [statement, setStatement] = useState([]);

  const getStatement = async () => {
    const data = { reff: props.reff };
    const server_response = await ajaxAccounting.getsupplierInvoice_statement(
      data
    );
    if (server_response.status === "OK") {
      setStatement(server_response.details);
    }
  };

  const getPaymentVoucher = async () => {
    const data = { InvoID: props.id };
    const server_response = await ajaxAccounting.get_Inventory_invoice(data);
    if (server_response.status === "OK") {
      setInvo_ifo(server_response.details.info);
      setInvo_details(server_response.details.details);
      setClientinfo(server_response.details.clientinfo);
      setLedgerID_debited_name(
        server_response.details.info.ledgerID_debited_name
      );
      setLedgerID_credited_name(
        server_response.details.info.ledgerID_credited_name
      );
    }
  };

  const amountToWords = (amount) => {
    const words = numberToWords.toWords(amount);
    return words.charAt(0).toUpperCase() + words.slice(1);
  };

  useEffect(() => {
    getPaymentVoucher();
    getStatement();
  }, []);

  const RenderFooter = (controls) => {
    return (
      <>
        <button
          className="btn ripple btn-dark"
          type="button"
          onClick={controls.close}
        >
          Close
        </button>
        <button
          className="btn ripple btn-dark"
          type="button"
          onClick={(e) => Print(e, controls)}
        >
          Print
        </button>
      </>
    );
  };

  return (
    <SystemModal
      title="Invoice Printing"
      id="model-new-ledger"
      size="lg"
      footer={RenderFooter}
    >
      <div id="printablediv">
        <div
          style={{
            fontFamily: "Arial, sans-serif",
            backgroundImage: `url(${process.env.PUBLIC_URL}/template/assets/images/doc_back.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
            width: "21cm",
            padding: "2cm",
          }}
        >
          {/* Header Section */}
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginBottom: "10px",
            }}
          >
            <div
              style={{ width: "80%", lineHeight: "4px", alignItems: "center" }}
            >
              <h3 align="left">BERICOT AFRICA LIMITED</h3>
              <p style={{ fontSize: "14px" }} align="left">
                P.O.BOX 28775 KAMPALA
              </p>
              <p style={{ fontSize: "14px" }} align="left">
                PLOT 79B MAKAMBA ROAD
              </p>
              <p style={{ fontSize: "14px" }} align="left">
                TEL :+256701666160
              </p>
              <p style={{ fontSize: "14px" }} align="left">
                EMAIL :info@bericot.africa
              </p>
              <h4 align="center">Invoice: {inv_info.Invo_no}</h4>
            </div>
            <div style={{ width: "20%" }}>
              <img
                style={{
                  position: "relative",
                  height: "100px",
                  width: "100px",
                }}
                src={`${process.env.PUBLIC_URL}/template/assets/images/bricote_logo.png`}
                alt="Logo"
              />
            </div>
          </div>

          {/* Project & Ledger Info */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
              color: "grey",
            }}
          >
            <p>
              <b>Project Name:</b> {inv_info.project_name}
            </p>
            <p>Journal Date: {inv_info.date}</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
              color: "grey",
            }}
          >
            <p>Ledger Debited: {ledgerID_debited_name}</p>
            <p>
              <b>Ledger Credited:</b> {ledgerID_credited_name}
            </p>
          </div>

          {/* Invoice Items Table */}
          <div
            style={{
              width: "100%",
              border: "1px solid black",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                border: "1px groove grey",
                color: "#000",
                textAlign: "center",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "rgba(51, 181, 255, 0.7)",
                    height: "30px",
                  }}
                >
                  <th>No</th>
                  <th>Items</th>
                  <th>Units</th>
                  <th>Rate</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(invo_details) &&
                  invo_details.map((item, key) => (
                    <tr
                      key={key}
                      style={{
                        color: "black",
                        height: "40px",
                        borderBottom: "1px grey solid",
                      }}
                    >
                      <td>{key + 1}</td>
                      <td>{item.product_name}</td>
                      <td>{item.plural}</td>
                      <td>{item.unit_cost.unit_cost_c}</td>
                      <td>{item.quantity_out.quantity_out_c}</td>
                      <td>{item.amount.amount_c}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Statement Section */}
          <div style={{ width: "100%", marginTop: "20px" }}>
            <h4 style={{ textAlign: "center" }}>Statement</h4>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid grey",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "rgba(200, 200, 200, 0.3)" }}>
                  <th>No</th>
                  <th>Supplier Ref</th>
                  <th>Date</th>
                  <th>Debit (Ugx)</th>
                  <th>Credit (Ugx)</th>
                  <th>Balance (Ugx)</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(statement) && statement.length > 0 ? (
                  statement.map((item, key) => (
                    <tr
                      key={key}
                      style={{ borderBottom: "1px solid grey", height: "30px" }}
                    >
                      <td>{key + 1}</td>
                      <td>{item.supplier_reff}</td>
                      <td>{new Date(item.date).toLocaleDateString()}</td>
                      <td>{item.debit.toLocaleString()}</td>
                      <td>{item.credit.toLocaleString()}</td>
                      <td>{item.balance.toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No statement available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Totals Section */}
          <div style={{ display: "block", marginTop: "20px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div></div>
              <div style={{ float: "right", width: "50%" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "2px groove grey",
                    textAlign: "center",
                  }}
                >
                  <tbody>
                    <tr
                      style={{ color: "black", borderBottom: "1px grey solid" }}
                    >
                      <td style={{ width: "150px" }}>
                        <b>Amount:</b>
                      </td>
                      <td style={{ width: "150px" }}>
                        Ugx{" "}
                        {inv_info.amount_crude &&
                          inv_info.amount_crude.amount_crude_c}
                      </td>
                    </tr>
                    <tr
                      style={{ color: "black", borderBottom: "1px grey solid" }}
                    >
                      <td style={{ width: "150px" }}>
                        <b>V.A.T(18%):</b>
                      </td>
                      <td style={{ width: "150px" }}>
                        Ugx {inv_info.vat && inv_info.vat.vat_c}
                      </td>
                    </tr>
                    <tr
                      style={{ color: "black", borderBottom: "1px grey solid" }}
                    >
                      <td style={{ width: "150px" }}>
                        <b>Total Amount:</b>
                      </td>
                      <td style={{ width: "150px" }}>
                        Ugx{" "}
                        {inv_info.Amount_vated &&
                          inv_info.Amount_vated.Amount_vated_c}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr style={{ border: "1px grey dotted", margin: "10px 0" }} />

            {/* Amount In Words */}
            <div style={{ textAlign: "left", marginTop: "10px" }}>
              <p>
                <b>Amount In Words:</b>{" "}
                <span style={{ color: "grey" }}>
                  <u>
                    {inv_info.Amount_vated &&
                      amountToWords(inv_info.Amount_vated.Amount_vated)}{" "}
                    shillings
                  </u>
                </span>
              </p>
            </div>

            {/* Footer Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "10px",
                color: "grey",
              }}
            >
              <div>
                <p>Authorized By: --------------------------</p>
              </div>
              <div>
                <p>Printed on: {new Date().toLocaleDateString()}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

export default InventoryJournalPrintableWzStatement;
